import * as Yup from "yup";

export const schema = Yup.object().shape({
  dictionaryValue: Yup.string().required("Введите значение справочника"),
});
